import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgNoticeableIrritationEmoji(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8 24c0-8.2-6.7-14.8-14.8-14.8-8.1 0-14.8 6.7-14.8 14.8 0 8.1 6.7 14.8 14.8 14.8 8.1 0 14.8-6.6 14.8-14.8ZM8 24c0-8.8 7.2-16 16-16s16 7.2 16 16-7.2 16-16 16S8 32.8 8 24Zm16 3.375c2.317 0 3.795 1.11 4.5 2.05l-1 .75c-.495-.66-1.617-1.55-3.5-1.55-1.859 0-3 .968-3.526 1.582l-.948-.814A5.816 5.816 0 0 1 24 27.375Zm7.4-2.875a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Zm2.1 4a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm.5-.8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1.5.8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-22.3.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1.5-1.8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm.5 1.8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm2.9-5.7a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0Z",
    fill: "currentColor"
  }));
}

export { SvgNoticeableIrritationEmoji as default };
